/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import {GET_MY, REQUEST_DATA_RESULT} from '../../containers/App/constants';
import {
  HIDE_MAIN_FORM,
  INITIATE_COMPANY_CREATE,
  INITIATE_COMPANY_EDIT,
  REQUEST_COMPANIES,
  REQUEST_COMPANY,
  REQUEST_COMPANY_FILTER,
  REQUEST_COMPANY_FILTER_RESET,
  REQUEST_COMPANY_PROPERTY,
  REQUEST_COMPANY_PROPERTY_NAMES,
  REQUEST_COMPANY_WORKFLOWS,
  REQUEST_COUNTRIES,
  REQUEST_HOME_COMPANY,
  REQUEST_IBAN_CHECK,
  SET_NEW_COMPANY_VALUE,
  SHOW_MAIN_FORM,
  TOGGLE_NOTIFICATION,
  UPDATE_COMPANY_FILTERS,
  ADD_COMPANY_TO_BULK_ACTIONS_LIST,
  REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST,
  REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST,
  REQUEST_COMPANIES_PROPERTY,
  REQUEST_COMPANIES_BY_IDS,
  UPDATE_COMPANY_SEARCH_STRING,
  APPLY_COMPANY_SORT_ORDER,
  REQUEST_COMPANY_HISTORY,
  UPDATE_COMPANY_HISTORY_SEARCH_STRING,
  UPDATE_COMPANY_HISTORY_FILTER,
  REQUEST_DUPLICATE_VAT_COMPANY,
} from './constants';
import { parseStoreCompany } from './helpers';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  properties: [],
  sortType: null,
  order: null,
};

export const initialState = {
  companies: [],
  isMainForm: false,
  filter: {
    ...DEFAULT_FILTER,
  },
  companiesCount: null,
  propertyNames: null,
  countries: null,
  newCompany: {},
  companyProperties: {},
  homeCompanyId: null,
  paginator: {},
  notification: {
    isShow: '0',
    message: '',
  },
  dunIdByName: {},
  companyBulkActionsList: [],
  historyLogs: [],
  filterHistoryLogs: {
    text: '',
    properties: [],
  },
};

export const companyReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action?.id) {
      case REQUEST_COMPANY_HISTORY:
        if (action?.result) {
          draft.historyLogs = action?.result?.items;
        }

        break;
    }
    switch (action.type) {
      case SHOW_MAIN_FORM:
        draft.isMainForm = true;
        return;
      case HIDE_MAIN_FORM:
        draft.isMainForm = false;
        return;

      case SET_NEW_COMPANY_VALUE:
        if (action.initiate) {
          draft.newCompany[action.name] = draft.newCompany[action.name] || '';
        } else draft.newCompany[action.name] = action.value;
        return;
      case REQUEST_COMPANY_FILTER:
        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
          if (action.name !== 'offset') draft.filter.offset = 0;
        }
        break;
      case APPLY_COMPANY_SORT_ORDER:
        draft.filter.sortType = action.sortType;
        draft.filter.order = action.order;
        break;
      case INITIATE_COMPANY_CREATE:
        if (draft.newCompany.id) {
          draft.newCompany = {};
        }
        break;
      case INITIATE_COMPANY_EDIT:
        try {
          draft.newCompany = {
            id: action.id,
          };
          draft.companies
            .find(c => c.id == action.id)
            .properties.map(p => {
              if (p !== 'addresses') {
                draft.newCompany[p.name.name] = p.value;
              }
              return null;
            });

          draft.newCompany.accountManagerId =
            draft.companies.find(c => c.id == action.id)?.accountManager?.id || draft.newCompany.accountManagerId;

          draft.newCompany.addresses = draft.companies.find(c => c.id == action.id)?.addresses;
        } catch (e) {
          // eslint-disable-next-line no-debugger
          debugger;
        }
        break;
      case TOGGLE_NOTIFICATION:
        if (action.isShow == '1') {
          draft.notification = {
            isShow: action.isShow,
            message: action?.message,
          };
        }
        if (action?.isShow == '0') {
          draft.notification = {
            isShow: action.isShow,
            message: '',
          };
        }
        break;
      case UPDATE_COMPANY_SEARCH_STRING:
        if (action?.text) {
          draft.filter.searchString = action.text;
        }
        break;
      case UPDATE_COMPANY_FILTERS:
      case REQUEST_COMPANY_FILTER:
        if ('propertyFilter' in action) {
          draft.filter.properties = draft.filter.properties
            .map(p => {
              if (p.key == action.propertyFilter?.key) return null;
              if (p.key == action.reset) return null;
              if (action.reset?.indexOf?.(p.key) > -1) {
                return null;
              }
              return p;
            })
            .filter(p => p);

          if (action.propertyFilter) draft.filter.properties.push(action.propertyFilter);
        }
        //clear empty values
        draft.filter.properties = draft.filter.properties.filter(p => p.value.length || p.value.id);

        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
        }
        if (action.name !== 'offset') draft.filter.offset = 0;
        break;
      case REQUEST_COMPANY_FILTER_RESET:
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        break;
      case ADD_COMPANY_TO_BULK_ACTIONS_LIST:
        if (action?.payload) {
          const isInList = draft.companyBulkActionsList?.filter(item => item?.id == action.payload?.id);

          draft.companyBulkActionsList = !isInList?.length
            ? [...draft.companyBulkActionsList, action.payload]
            : draft.companyBulkActionsList;
        }
        return;
      case REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST:
        if (action?.companyId) {
          draft.companyBulkActionsList = draft.companyBulkActionsList.filter(item => item?.id != action?.companyId);
        }
        return;
      case REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST:
        draft.companyBulkActionsList = [];
        return;
      case UPDATE_COMPANY_HISTORY_SEARCH_STRING:
        draft.filterHistoryLogs.text = action?.text;
        break;
      case UPDATE_COMPANY_HISTORY_FILTER:
        draft.filterHistoryLogs.properties = action?.properties;
        break;
      case GET_MY:
        switch (action.id) {
          case REQUEST_IBAN_CHECK:
            try {
              const results = draft.ibanCheckResults ?? {};
              const companyId = action.gate.split('-')[1];
              results[`${companyId}`] = null;
              draft.ibanCheckResults = results;
            } catch (error) {
              //
            }
            break;
        }
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_COMPANIES:
            draft.companies = action.result.items.map(parseStoreCompany);
            draft.paginator = action.result.paginator;
            draft.companiesCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_COMPANIES_BY_IDS:
            action.result.forEach(company => {
              try {
                const index = draft.companies.findIndex(item => item.id === company.id);
                const parsedCompany = parseStoreCompany(action.result);
                if (index > -1) draft.companies[index] = parsedCompany;
                else draft.companies.push(parsedCompany);
              } catch (e) {
                console.error(e);
              }
            });
            break;
          case REQUEST_COMPANY:
            try {
              const index = draft.companies.findIndex(item => item.id === action.result.id);
              const company = parseStoreCompany(action.result);
              if (index > -1) draft.companies[index] = company;
              else draft.companies.push(company);
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_DUPLICATE_VAT_COMPANY:
            try {
              draft.duplicateVatCompany = parseStoreCompany(action.result);
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_HOME_COMPANY:
            if (action.result) {
              draft.homeCompanyId = action.result?.id;
              localStorage.setItem('home-company-id', JSON.stringify(action.result?.id ?? null));
            }
            break;
          case REQUEST_COMPANY_PROPERTY_NAMES:
            draft.propertyNames = action.result;
            break;
          case REQUEST_COUNTRIES:
            draft.countries = action.result;
            localStorage.setItem('countries', JSON.stringify(action.result));
            break;
          case REQUEST_COMPANY_PROPERTY:
            if (!(action.companyId in draft.companyProperties)) draft.companyProperties[action.companyId] = {};
            if (action?.result?.message) {
              draft.companyProperties[action.companyId][action.propertyName] = undefined;
              return;
            }
            draft.companyProperties[action.companyId][action.propertyName] = action.result;
            break;
          case REQUEST_COMPANIES_PROPERTY:
            action.result.forEach(({ companyId, value, name }) => {
              if (!(companyId in draft.companyProperties)) draft.companyProperties[companyId] = {};
              draft.companyProperties[companyId][name] = value;
            });
            break;
          case REQUEST_IBAN_CHECK:
            try {
              const results = draft.ibanCheckResults ?? {};
              const companyId = action.gate.split('-')[1];
              results[`${companyId}`] = action.result;
              draft.ibanCheckResults = results;
            } catch (error) {
              //
            }
            break;
          case 'dunIdByName':
            draft.dunIdByName[action.companyId] = action.result.data;
            debugger;
            break;
          case REQUEST_COMPANY_WORKFLOWS:
            draft.companyWorkflows = action.result;
            break;
        }
    }
  });
